import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs';
import { AlertService } from 'src/app/core/services/alert.service';
import { LanguageService } from 'src/app/core/services/language.service';
import { RouterService } from 'src/app/core/services/router.service';
import { RootReducerState } from 'src/app/modals';
import { completeConnectionPayment } from 'src/app/modals/PaymentGateway/payment-gateway.action';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-payment-gateway-callback',
  templateUrl: './payment-gateway-callback.component.html',
  styleUrls: ['./payment-gateway-callback.component.scss'],
  standalone:true,
  imports:[TranslateModule]
})


export class PaymentGatewayCallbackComponent implements OnInit {

  constructor(
    private store: Store<RootReducerState>,
    private route: ActivatedRoute,
    public alertService: AlertService,
    private router: Router,
    private routeService: RouterService,
    public translate: TranslateService,
    public languageService: LanguageService
  ) { }

  ngOnInit() {
    this.setupQueryParam();
  }

  setupQueryParam() {

    this.route.queryParamMap.pipe(take(1)).subscribe(params => {

      const error = params.get('error') ?? "";
      const code = params.get('code') ?? "";
      const state = params.get('state') ?? "";

      // Extract club_id from state string: "<uuid>___club_id=<id>"
      const club_id = state.includes('___club_id=')
        ? (state.split('___club_id=')[1]?.trim() || "")
        : "";

      if (club_id == "") {
        if (error === 'access_denied' || code == "") {
          this.alertService.triggerAlert("ALERTS.connect-failed", "error");
          this.routeService.triggerRoute(null, "/payment-gateway-settings");
        }
        else if (state !== "") {
          this.store.dispatch(completeConnectionPayment({ data: { code: code, state: state, club_id: club_id } }));
        }
      }
      else {
        var url = environment.contributie + `clubs/${club_id}/settings?club_id=${club_id}&error=${error}&code=${code}&state=${state}`;
        window.location.href = url;
      }

    });

  }

}